import { Component, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { PartnerService } from 'src/app/shared/services/partner.service';

@Component({
  selector: 'app-custom-pagination',
  templateUrl: './custom-pagination.component.html',
  styleUrls: ['./custom-pagination.component.scss']
})
export class CustomPaginationComponent implements OnInit {

  @ViewChild('paginatorPage') paginatorPage: MatPaginator;

  @Input() data: any;

  currentPage: number;
  totalPages: number;

  pageSize = 100;
  length: number;

  constructor(private partnerService: PartnerService) { }

  ngOnInit() {
    this.length = this.data.total_items;
    this.totalPages = this.data.total_pages;
    this.pageSize = this.data.page_size;
    this.currentPage = this.data.page - 1;
  }

  changePage(event: PageEvent){

    var changingPage = false;
    var changingPageSize = false;

    if(this.currentPage != event.pageIndex){
      changingPage = true;
    }
    if(this.pageSize != event.pageSize){
      changingPageSize = true;
    }

    this.pageSize = event.pageSize;
    this.currentPage = event.pageIndex;


    if(changingPage){
      this.partnerService.setTablePage(this.currentPage + 1);
    }

    if(changingPageSize){
      this.partnerService.setTablePageSize(this.pageSize);
      this.partnerService.setTablePage(this.currentPage + 1);
    }



  }
}
